import { createSelector } from 'reselect';

import {
  CATERING_SALE_TYPES,
  SALE_TYPE,
  SALE_TYPE_WITH_SUBS,
} from '../constants/saleType';
import { getEnabledSaleTypes } from './config';

const subSaleTypes: Record<SALE_TYPE_WITH_SUBS, SALE_TYPE[]> = {
  [SALE_TYPE.CATERING]: CATERING_SALE_TYPES,
};

export default (saleType?: SALE_TYPE_WITH_SUBS) =>
  createSelector([getEnabledSaleTypes], enabledSaleTypes => {
    if (!saleType) {
      return [];
    }

    const displayableSubSaleTypes = subSaleTypes[saleType].filter(subSaleType =>
      enabledSaleTypes.includes(subSaleType),
    );

    return displayableSubSaleTypes;
  });
